import { forwardRef, ForwardRefRenderFunction, ReactNode } from 'react';

import ReactDOM from 'react-dom';

import { useIsMounted } from '~/shared/hooks/isMounted';

import { Container } from './styles';

interface BackdropProps {
  children: ReactNode;
}

const BaseBackdrop: ForwardRefRenderFunction<HTMLDivElement, BackdropProps> = (
  { children },
  ref
) => {
  const isMounted = useIsMounted();

  if (!isMounted) return null;

  return ReactDOM.createPortal(
    <Container ref={ref}>{children}</Container>,
    document.getElementById('backdrop-root')
  );
};

export const Backdrop = forwardRef(BaseBackdrop);
